export const removeReCaptchaScript = (id: string): void => {
  // Intentar resetear el widget de reCAPTCHA si es posible
  try {
    const script = document.getElementById(id);

    if (script && window.grecaptcha) {
      window.grecaptcha = undefined; // Esto elimina la referencia de reCAPTCHA del objeto window
    }

    // Remover el script del DOM
    if (script) {
      document.head.removeChild(script);
    }

    // Adicionalmente, puedes buscar eliminar el contenedor del widget de reCAPTCHA si tienes uno
    const widgetContainer = document.querySelector('.grecaptcha-badge');

    if (widgetContainer) {
      widgetContainer.parentElement.innerHTML = ''; // Esto limpia el contenido del contenedor
    }
  } catch (error) {
    console.error('Error removing reCAPTCHA script:', error);
  }
};

export const loadReCaptchaScript = (
  src: string,
  id: string,
  onLoadCallback: () => void
): Promise<void> => {
  return new Promise((resolve, reject) => {
    // Verificar si el script ya ha sido cargado
    const existeScript = document.getElementById(id);
    if (existeScript) {
      onLoadCallback();
      resolve();
    }

    const script = document.createElement('script');
    script.id = 'captcha-v3';
    script.src = src;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      onLoadCallback();
      resolve();
    };
    script.onerror = (error) => reject(error);

    document.head.appendChild(script);
  });
};
